import Selectors from './utils/selectors.js';
import ResponseHandler from './utils/response-handler.js';
import RequestHandler from './utils/request-handler.js';

export default class Insurance {
    constructor() {
        this.dataIdentifier = 'data-insurance';
        this.elementIdentifier = 'insurance';
        this.addFormIdentifier = 'add_form';
        this.confirmationMessageIdentifier = this.elementIdentifier + '_confirmation_message';
        this.confirmationMessage = 'Please accept the terms and conditions before submitting this form.';
        this.responseHandler = new ResponseHandler;
        this.requestHandler = new RequestHandler;
        this.selectors = new Selectors({
            dataAttrId: this.dataIdentifier
        });
    }

    setup() {
        this.setupFormListener();
    }

    setupFormListener() {
        document.addEventListener('submit', (event) => {
            let formElement = event.target;
            if (!formElement.hasAttribute(this.dataIdentifier)) {
                return;
            }

            let data = {
                'publicId': formElement.querySelector(this.selectors.nameAttr('publicId')).value,
                'insuranceConfirmed': formElement.querySelector(this.selectors.nameAttr('insurance_confirmation_box')).checked,
            };

            let alertElement = formElement.querySelector(this.selectors.dataAttr(this.confirmationMessageIdentifier));
            alertElement.innerText = '';

            if (formElement.getAttribute(this.dataIdentifier) == this.addFormIdentifier && !data['insuranceConfirmed']) {
                alertElement.innerText = this.confirmationMessage;
                event.preventDefault();
            }

            /**
             * @TODO JIRA PRB-490 Convert POST form to AJAX
             *
             * this.requestHandler.post(
             *     formElement.action,
             *     data,
             *     this.updateInsuranceCallback.bind(this)
             * );
            */
        });
    }

    updateInsuranceCallback() {

        /**
         * @TODO JIRA PRB-490
         * - Close the modal after submission.
         * - Populate the returned message.
         * - Update the basket deal line with the new status
         */
    }
}
